import React from 'react';
import CityMap from './ServiceMap';
import PuneItMap from './PuneItMap';



const OurNetwork = () => {
  return (
    <>
      <section
        className="page-title"
        style={{
          backgroundImage: 'url(/images/background/3.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '100px 0',
          color: '#fff',
          textAlign: 'center',
          overflowX: 'hidden'
        }}
      >
        <div className="auto-container">
          <h1 style={{ fontSize: '36px', fontWeight: 'bold' }}>Our Network</h1>
        </div>
      </section>

 

      {/* ✅ Wrap the maps in a container and row */}
      <section style={{ padding: '60px 20px', backgroundColor: '#f8f8f8' }}>
        <div className="auto-container">
          <div className="row" style={{ display: 'flex', flexWrap: 'wrap', gap: '30px' }}>
            <div className="col-12 col-md-6" style={{ flex: '1 1 45%' }}>
              <CityMap />
            </div>
            <div className="col-12 col-md-6" style={{ flex: '1 1 45%' }}>
              <PuneItMap />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OurNetwork;
